import { EditOutlined, LockOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { FillingMethod } from 'entities/FormField';
import { isDataTypeWithoutFillingMethod } from 'stores/local/forms/models';

import { ColumnBaseProps } from '../types';

const ImportEditableColumn: React.FC<ColumnBaseProps> = ({ record }) => {
  // Only show toggle for import fields
  if (
    record.formField.fillingMethod !== FillingMethod.import ||
    isDataTypeWithoutFillingMethod(record.formField)
  ) {
    return null;
  }

  return (
    <Switch
      disabled={record.catalogField.required}
      checkedChildren={<EditOutlined />}
      unCheckedChildren={<LockOutlined />}
      checked={record.formField.importEditable}
      onClick={record.formField.importEditableToggleModel.toggle}
    />
  );
};

export default observer(ImportEditableColumn);
